import React from 'react';
import { useModalsContext, useStoreConfigContext } from '/src/providers';
import { Modal, H2, Form, useForm } from '/src/components';

const SmsPhone = ({ phone = '', setPhone }) => {
    const { translate } = useStoreConfigContext();
    const { hideModal } = useModalsContext();
    const { data, handleChange } = useForm({ phone });

    const handleSubmit = e => {
        e.preventDefault();

        setPhone(data.phone);
        hideModal();
    };

    return (
        <Modal toggle={hideModal} login>
            <H2>{translate('Telephone')}</H2>
            <Form onSubmit={handleSubmit}>
                <Form.Column mt>
                    <Form.Input
                        placeholder={translate('Telephone')}
                        type="tel"
                        name="phone"
                        onChange={handleChange}
                        value={data.phone}
                    />
                </Form.Column>
                <Form.Column mt>
                    <Form.Button>
                        {translate('Continue')}
                    </Form.Button>
                </Form.Column>
            </Form>
        </Modal>
    )
};

export default SmsPhone;
